import React from 'react';
import { withStyles } from 'tss-react/mui';

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import WaveSelectField from '../../../../common/components/form/WaveSelectField';
import CsvImportForm from '../../import/CsvImportForm';

const styles = (theme) => ({
  csvFile: {
    paddingLeft: theme.typography.pxToRem(15)
  },
  fileImportHeaders: {
    paddingBottom: theme.typography.pxToRem(15)
  },
  fileUploadContainer: {
    padding: `${theme.typography.pxToRem(25)} 0 ${theme.typography.pxToRem(
      35
    )} ${theme.typography.pxToRem(25)}`
  },
  hideInput: {
    display: 'none'
  },
  uploadCsv: {
    marginBottom: theme.typography.pxToRem(30)
  }
});

class ImportForm extends React.Component {
  render() {
    const { classes, file, onCsvFileChange, year, yearsRange, onYearChange, templateFilename } = this.props;

    return (
      <CsvImportForm classes={classes} file={file} onCsvFileChange={onCsvFileChange} templateFilename={templateFilename}>
        <Grid size={6}>
          <Typography className={classes.fileImportHeaders} variant="h6">
            Effective Year
          </Typography>
          <WaveSelectField
            noValidation
            label="Year"
            menuItems={yearsRange}
            name="year"
            value={year}
            onChange={onYearChange}
          />
        </Grid>
      </CsvImportForm>
    );
  }
}

export default withStyles(ImportForm, styles, { withTheme: true });
